import {
  BaseEdge,
  EdgeProps,
  getSmoothStepPath,
  Position,
} from '@xyflow/react';

import { flowUtilConsts } from '../utils/consts';
import { ApRouterStartEdge } from '../utils/types';

import { ApAddButton } from './add-button';
import { BranchLabel } from './branch-label';

export const ApRouterStartCanvasEdge = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
  data,
  source,
  target,
  id,
}: EdgeProps & Omit<ApRouterStartEdge, 'position'>) => {
  const sourcePosition = Position.Right;
  const targetPosition = Position.Left;
  const [edgePath] = getSmoothStepPath({
    sourceX: sourceX,
    sourceY: sourceY,
    sourcePosition,
    targetX: data.isBranchEmpty
      ? targetX - flowUtilConsts.AP_NODE_SIZE.BIG_ADD_BUTTON.width / 2
      : targetX,
    targetY: data.isBranchEmpty
      ? targetY + flowUtilConsts.AP_NODE_SIZE.BIG_ADD_BUTTON.height / 1.8
      : targetY,
    targetPosition,
  });

  return (
    <g>
      <BaseEdge
        path={edgePath}
        className="animated-edge"
        style={{
          strokeWidth: `${flowUtilConsts.LINE_WIDTH}px`,
          stroke: data.hover ? '#ff0000' : '#999999',
          transition: 'stroke 0.2s ease',
        }}
      />
      <foreignObject
        x={targetX - flowUtilConsts.AP_NODE_SIZE.STEP.width * 2}
        y={data.isBranchEmpty ? targetY + 18 : targetY - 9}
        width={flowUtilConsts.AP_NODE_SIZE.ADD_BUTTON.width + 150}
        height={flowUtilConsts.AP_NODE_SIZE.ADD_BUTTON.height}
        className="overflow-visible"
      >
        <div className="flex items-center justify-between w-full h-full">
          <BranchLabel
            key={data.label + target}
            sourceNodeName={source}
            targetNodeName={target}
            stepLocationRelativeToParent={data.stepLocationRelativeToParent}
            branchIndex={data.branchIndex}
            label={data.label}
          />
          {!data.isBranchEmpty && data.hover && (
            <ApAddButton
              edgeId={id}
              stepLocationRelativeToParent={data.stepLocationRelativeToParent}
              parentStepName={source}
              branchIndex={data.branchIndex}
            />
          )}
        </div>
      </foreignObject>
    </g>
  );
};
